module.exports = __webpack_public_path__ + "static/media/gal-11.91f66e92.jpeg";